/*
 * Popup 1 de salida — PetBeat México (WhatsApp)
 *
 * - Solo móvil (≤768px). No en la home.
 * - Se muestra EN CADA VISITA a la página (una vez por página vista), sin importar cuántas veces haya entrado,
 *   mientras la persona no haya comprado (window.pbPurchased, ver theme.liquid y el pixel de "Eventos de clientes").
 * - Disparadores: primer intento de salir (botón/gesto "atrás") y 19 s de inactividad.
 * - El segundo intento de salir lo atiende el popup del regalo (exit-intent-regalo.js).
 * - Diagnóstico: agregar ?pbdebug=1 a la URL muestra un registro en pantalla.
 */

(function () {
  'use strict';

  window.pbLog = function () {};
  if (/[?&]pbdebug=1/.test(window.location.search)) {
    const box = document.createElement('div');
    box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;max-height:30vh;overflow:auto;padding:6px 8px;background:#000c;color:#0f0;font:11px/1.3 monospace;white-space:pre-wrap;pointer-events:none';
    const add = (msg) => {
      box.textContent += msg + '\n';
      box.scrollTop = box.scrollHeight;
      if (!box.parentNode && document.body) document.body.appendChild(box);
    };
    window.pbLog = (m) => add(Math.round(performance.now() / 100) / 10 + 's ' + m);
    window.addEventListener('error', (e) => add('ERROR ' + e.message));
    window.addEventListener('popstate', () => add('popstate hist=' + window.history.length));
    add('w=' + window.innerWidth + ' compro=' + !!window.pbPurchased + ' ua=' + navigator.userAgent.slice(-40));
  }

  const CONFIG = {
    id: 'pb-exit-popup',
    whatsapp: '525561102804',
    mobileBreakpoint: 768,
    inactivityMs: 19000,
  };

  const ExitIntent = {
    shown: false,
    popup: null,
    inactivityTimer: null,
    lastFocus: null,
    hasEntry: false,

    init() {
      if (window.pbPurchased) {
        window.pbLog('p1 omitido: ya compró');
        return;
      }
      if (window.innerWidth > CONFIG.mobileBreakpoint) {
        window.pbLog('p1 omitido: pantalla ancha ' + window.innerWidth);
        return;
      }
      if ((window.location.pathname.replace(/\/+$/, '') || '/') === '/') {
        window.pbLog('p1 omitido: home');
        return;
      }
      window.pbLog('p1 init ok');
      this.render();
      this.attachTriggers();
    },

    attachTriggers() {
      // 1. Botón "atrás". Se intenta crear la entrada de historial desde el inicio; si el navegador la ignora
      //    (Safari/Chrome lo hacen hasta que hay un toque), se vuelve a crear en el primer toque.
      try {
        window.history.pushState({ pbExit: true }, '', window.location.href);
        this.hasEntry = true;
      } catch (e) {
        /* se crea en el primer toque */
      }

      this.onPopState = (e) => {
        this.hasEntry = false;
        window.pbLog('p1 popstate shown=' + this.shown);
        if (this.shown) return;
        this.show(e);
        try {
          window.history.pushState({ pbExit: true }, '', window.location.href);
        } catch (err) {
          /* el popup del regalo repone la entrada en el siguiente toque */
        }
      };
      window.addEventListener('popstate', this.onPopState);

      this.ensureEntry = () => {
        if (this.shown || this.hasEntry) return;
        window.history.pushState({ pbExit: true }, '', window.location.href);
        this.hasEntry = true;
        window.pbLog('p1 entrada de historial creada (toque)');
      };
      ['touchend', 'click'].forEach((evt) =>
        document.addEventListener(evt, this.ensureEntry, { passive: true, capture: true })
      );

      // 2. Inactividad.
      this.resetInactivity = () => {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = setTimeout(() => this.show(null), CONFIG.inactivityMs);
      };
      ['touchstart', 'touchmove', 'mousemove', 'keydown', 'scroll'].forEach((evt) =>
        document.addEventListener(evt, this.resetInactivity, { passive: true })
      );
      this.resetInactivity();
    },

    detachTriggers() {
      clearTimeout(this.inactivityTimer);
      window.removeEventListener('popstate', this.onPopState);
      ['touchend', 'click'].forEach((evt) => document.removeEventListener(evt, this.ensureEntry, { capture: true }));
      ['touchstart', 'touchmove', 'mousemove', 'keydown', 'scroll'].forEach((evt) =>
        document.removeEventListener(evt, this.resetInactivity)
      );
    },

    whatsappMessage() {
      const h1 = document.querySelector('h1');
      const name = h1 && h1.textContent ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
      return name && window.location.pathname.indexOf('/products/') === 0
        ? 'Hola PetBeat 👋 Tengo una duda sobre: ' + name
        : 'Hola PetBeat 👋 Tengo una duda sobre sus productos.';
    },

    render() {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = `
        <div class="pb-exit" id="${CONFIG.id}" role="dialog" aria-modal="true" aria-labelledby="pb-exit-title" hidden>
          <div class="pb-exit__card">
            <button type="button" class="pb-exit__close" aria-label="Cerrar" data-pb-exit-close>
              <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
                <path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </button>
            <p class="pb-exit__eyebrow">🐾 Antes de irte…</p>
            <h2 class="pb-exit__title" id="pb-exit-title">¿Te quedó alguna duda?</h2>
            <p class="pb-exit__text">
              Escríbenos por WhatsApp y te ayudamos a elegir lo ideal para tu perro.
              Te responde una persona real, de lunes a viernes de 9:00 a 18:00.
            </p>
            <a class="pb-exit__cta pb-exit__cta--wa" data-pb-exit-wa target="_blank" rel="noopener"
               href="https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(this.whatsappMessage())}">
              <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3Z"/></svg>
              Escribir por WhatsApp
            </a>
            <button type="button" class="pb-exit__skip" data-pb-exit-close>Seguir viendo</button>
          </div>
        </div>
      `;
      this.popup = wrapper.firstElementChild;
      document.body.appendChild(this.popup);
      this.injectStyles();

      this.popup.querySelectorAll('[data-pb-exit-close]').forEach((btn) => btn.addEventListener('click', () => this.hide()));
      this.popup.addEventListener('click', (e) => {
        if (e.target === this.popup) this.hide();
      });
      this.popup.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.hide();
      });
      const wa = this.popup.querySelector('[data-pb-exit-wa]');
      if (wa) wa.addEventListener('click', () => this.hide());
    },

    // event = el popstate que lo disparó (o null si fue por inactividad). El popup del regalo lo usa
    // para no abrirse con ese mismo "atrás".
    show(event) {
      if (this.shown || !this.popup) return;
      const gift = document.getElementById('pb-gift-popup');
      if (gift && !gift.hidden) {
        this.resetInactivity && this.resetInactivity();
        return;
      }
      this.shown = true;
      window.pbExitShown = true;
      window.pbExitShowEvent = event || null;
      window.pbLog('p1 SHOW');
      this.detachTriggers();
      this.lastFocus = document.activeElement;
      this.popup.hidden = false;
      this.popup.querySelector('.pb-exit__close').focus({ preventScroll: true });
    },

    hide() {
      if (!this.popup) return;
      this.popup.hidden = true;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },

    injectStyles() {
      const css = `
        .pb-exit {
          --pbx-green: #2e3a24;
          --pbx-gold: #c6a038;
          --pbx-ivory: #f6f1eb;
          --pbx-ebony: #0f0f10;
          position: fixed;
          inset: 0;
          z-index: 2147483000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: max(16px, env(safe-area-inset-top)) 16px max(16px, env(safe-area-inset-bottom));
          background: rgb(15 15 16 / 0.62);
          font-family: var(--font-body--family, 'Inter', system-ui, -apple-system, sans-serif);
          animation: pbx-fade 0.25s ease-out;
        }
        .pb-exit[hidden] { display: none; }
        .pb-exit__card {
          position: relative;
          width: 100%;
          max-width: 380px;
          max-height: calc(100dvh - 32px);
          overflow-y: auto;
          box-sizing: border-box;
          padding: 36px 24px 20px;
          border: 1px solid rgb(198 160 56 / 0.45);
          border-radius: 20px;
          background: var(--pbx-green);
          color: var(--pbx-ivory);
          text-align: center;
          box-shadow: 0 24px 60px rgb(15 15 16 / 0.45);
          animation: pbx-rise 0.3s ease-out;
        }
        .pb-exit__close {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 44px;
          height: 44px;
          display: grid;
          place-items: center;
          padding: 0;
          border: 1px solid rgb(246 241 235 / 0.35);
          border-radius: 50%;
          background: rgb(246 241 235 / 0.08);
          color: var(--pbx-ivory);
          cursor: pointer;
        }
        .pb-exit__eyebrow {
          margin: 0 0 10px;
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--pbx-gold);
        }
        .pb-exit__title {
          margin: 0 auto 18px;
          max-width: 15em;
          font-family: var(--pb-serif-font, 'Cormorant', Georgia, 'Times New Roman', serif);
          font-weight: 500;
          font-size: 1.85rem;
          line-height: 1.1;
          color: var(--pbx-ivory);
          text-wrap: balance;
        }
        .pb-exit__text {
          margin: 0 auto 18px;
          max-width: 21em;
          font-size: 0.9rem;
          line-height: 1.5;
          color: rgb(246 241 235 / 0.78);
        }
        .pb-exit__cta--wa {
          display: flex !important;
          align-items: center;
          justify-content: center;
          gap: 10px;
          text-decoration: none;
        }
        .pb-exit__cta {
          display: block;
          width: 100%;
          min-height: 54px;
          border: 0;
          border-radius: 999px;
          background: var(--pbx-gold);
          color: var(--pbx-ebony);
          font: inherit;
          font-size: 1rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          cursor: pointer;
        }
        .pb-exit__skip {
          display: block;
          width: 100%;
          min-height: 44px;
          margin-top: 6px;
          border: 0;
          background: none;
          color: rgb(246 241 235 / 0.7);
          font: inherit;
          font-size: 0.85rem;
          text-decoration: underline;
          text-underline-offset: 3px;
          cursor: pointer;
        }
        .pb-exit button:focus-visible, .pb-exit a:focus-visible { outline: 2px solid var(--pbx-gold); outline-offset: 2px; }
        @media (max-width: 360px) {
          .pb-exit__card { padding-inline: 18px; }
        }
        @media (max-height: 620px) {
          .pb-exit__card { padding-top: 28px; }
          .pb-exit__title { font-size: 1.5rem; margin-bottom: 12px; }
          .pb-exit__text { margin-bottom: 12px; }
        }
        @keyframes pbx-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pbx-rise { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
        @media (prefers-reduced-motion: reduce) {
          .pb-exit, .pb-exit__card { animation: none; }
        }
      `;
      const style = document.createElement('style');
      style.id = 'pb-exit-styles';
      style.textContent = css;
      document.head.appendChild(style);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ExitIntent.init());
  } else {
    ExitIntent.init();
  }
})();
